import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'

import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'
import { ServicesContext } from 'services/context'

import { createColumns } from './columns.description'
import { createColumns as createFavoriteColumns } from './columnsFavorite.columns.description'
import BeneficiariesComponent from './component'

export default combine(
  withTableController({ id: 'athlete-table' }),
  withTableController({ id: 'favorite-athlete-table' }),
  withContext(
    'tournamentService',
    ServicesContext,
    ({ tournamentService }) => tournamentService
  ),
  withContext(
    'followerService',
    ServicesContext,
    ({ followerService }) => followerService
  ),
  withContext('appStore', StoreContext),
  withMemo('columns', () => createColumns(), []),
  withMemo('favoriteColumns', () => createFavoriteColumns(), []),
  withCallbacks(
    {
      loadAthletes:
        ({ tournamentService }) =>
        async (tableState) =>
          await tournamentService.query({
            page: tableState.page,
            size: tableState.pageSize,
          }),

      loadFavoriteAthlete:
        ({ followerService }) =>
        async (tableState) =>
          await followerService.getTournamentFollowers({
            page: tableState.page,
            size: tableState.pageSize,
          }),

      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
    },
    []
  )
)(BeneficiariesComponent)
